import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import type { RoleFormItem, RoleSubmitValuesType } from "./RoleForm"

export const ROLE_FORM_SUBMITTED = "role/form/submitted"
export const roleFormSubmitted = (oldValue: Maybe<RoleFormItem>, newValue: RoleSubmitValuesType) => ({
    type: ROLE_FORM_SUBMITTED,
    payload: {
        oldValue: oldValue,
        newValue: newValue,
    },
})

export const DELETE_ROLE_CLICKED = "role/delete/clicked"
export const deleteRoleClicked = (id: string) => ({
    type: DELETE_ROLE_CLICKED,
    payload: {
        id: id,
    },
})

export const CLOSE_ROLE_FORM_CLICKED = "role/close/clicked"
export const closeRoleFormClicked = () => ({
    type: CLOSE_ROLE_FORM_CLICKED,
})
